import { RefObject, useEffect } from 'react';

export const useOnClickOutside = <E extends HTMLElement = HTMLElement>(
    ref: RefObject<E | null>,
    onClick: () => void,
) => {
    useEffect(() => {
        const onDocumentClick = (e: MouseEvent) => {
            const target = e.target as Node;
            const isOutside = ref.current && !ref.current.contains(target);

            if (isOutside) {
                onClick();
            }
        };
        document.addEventListener('click', onDocumentClick);
        return () => {
            document.removeEventListener('click', onDocumentClick);
        };
    }, [onClick, ref]);
};
